<era-group-list-item-ui [group]="group()"
                        [isEditing]="isEditing()"
                        [isSelected]="isSelected()"
                        (deleteEvent)="deleteEvent($event)"></era-group-list-item-ui>